import { Outlet } from "react-router-dom";
import Header from "./Component/Header";
import { useState } from "react";
import "./App.css";
import { ThemeContext } from "./Conterxts/ThemeContext";

const App = () => {
  const [IsDark, setIsDark] = useState(JSON.parse(localStorage.getItem('IsDarkMode')))
  return (
    <ThemeContext.Provider value={[IsDark, setIsDark]}>
      <Header />
      <Outlet />
    </ThemeContext.Provider>
  );
};

export default App;
